/**
 * Nepali translations.
 *
 * The key IS the English text. That is the whole trick: `t('Orders')` renders
 * "Orders" in English and "अर्डरहरू" in Nepali, and a string that has no entry
 * here simply renders its English self instead of an ugly `missing.key`. So the
 * app can be translated a screen at a time without anything ever breaking.
 *
 * To translate a new string:
 *   1. Wrap it at the call site:  {t('Save changes')}
 *   2. Add one line below:        'Save changes': 'परिवर्तन सुरक्षित गर्नुहोस्',
 *
 * Placeholders use {braces} and are filled by the second argument to t():
 *   t('Token #{n} started.', { n: 5 })
 */

const ne = {
  // ---------------------------------------------------------------- navigation
  'Businesses': 'व्यवसायहरू',
  'Dashboard': 'ड्यासबोर्ड',
  'Orders': 'अर्डरहरू',
  'Counter': 'काउन्टर',
  'Dues': 'उधारो',
  'Expenses': 'खर्च',
  'Savings': 'बचत',
  'Staff': 'कर्मचारी',
  'Reports': 'रिपोर्ट',
  'Settings': 'सेटिङ',
  'User Management': 'प्रयोगकर्ता व्यवस्थापन',
  'Notes': 'नोट',

  // -------------------------------------------------------------------- header
  'Restaurant Management System': 'रेस्टुरेन्ट व्यवस्थापन प्रणाली',
  'Cafe Manager': 'क्याफे म्यानेजर',
  'Professional Management System': 'व्यावसायिक व्यवस्थापन प्रणाली',
  'Super Admin': 'सुपर एडमिन',
  'Viewing': 'हेर्दै',
  'Exit': 'बाहिर निस्कनुहोस्',
  'Refresh Data': 'डाटा रिफ्रेस गर्नुहोस्',
  'Change Password': 'पासवर्ड परिवर्तन गर्नुहोस्',
  'Password': 'पासवर्ड',
  'Logout': 'लगआउट',
  'Language': 'भाषा',

  // --------------------------------------------------------------------- login
  'Welcome Back': 'पुनः स्वागत छ',
  'Sign in to your restaurant management system': 'आफ्नो रेस्टुरेन्ट व्यवस्थापन प्रणालीमा साइन इन गर्नुहोस्',
  'Username or Email': 'प्रयोगकर्ता नाम वा इमेल',
  'Enter your username or email': 'आफ्नो प्रयोगकर्ता नाम वा इमेल लेख्नुहोस्',
  'Enter your password': 'आफ्नो पासवर्ड लेख्नुहोस्',
  'Sign In': 'साइन इन',
  'Signing in...': 'साइन इन हुँदै छ...',
  'Please enter both username and password': 'कृपया प्रयोगकर्ता नाम र पासवर्ड दुवै लेख्नुहोस्',
  'Login failed. Please check your credentials.': 'लगइन असफल भयो। कृपया आफ्नो विवरण जाँच्नुहोस्।',

  // ----------------------------------------------------------------- dashboard
  "Today's sale": 'आजको बिक्री',
  'Serving now': 'अहिले सेवारत',
  'Open Tokens': 'खुला टोकन',
  'Tokens': 'टोकन',
  'Unpaid': 'बाँकी रकम',
  "Today's Revenue": 'आजको आम्दानी',
  'Today': 'आज',
  'Adding to token': 'यो टोकनमा थपिँदै',
  'nothing on it yet': 'अहिलेसम्म केही छैन',
  'No token started': 'कुनै टोकन सुरु भएको छैन',
  'The token you were on belongs to an earlier session. Tap an item to start a new one.':
    'तपाईं भएको टोकन अघिल्लो सत्रको हो। नयाँ सुरु गर्न कुनै वस्तुमा थिच्नुहोस्।',
  'Tap an item to start one, or pick up an open token below.':
    'सुरु गर्न कुनै वस्तुमा थिच्नुहोस्, वा तलको खुला टोकन रोज्नुहोस्।',
  'New Token': 'नयाँ टोकन',
  'Create Token': 'टोकन बनाउनुहोस्',
  'Close Counter': 'काउन्टर बन्द गर्नुहोस्',
  'Close counter': 'काउन्टर बन्द गर्नुहोस्',
  'Open Counter': 'काउन्टर खोल्नुहोस्',
  'The counter is closed': 'काउन्टर बन्द छ',
  'Open it with your starting cash to begin taking orders.':
    'अर्डर लिन सुरु गर्न सुरुको नगद हालेर काउन्टर खोल्नुहोस्।',
  'Counter details': 'काउन्टरको विवरण',
  'Opened {time}': '{time} मा खोलिएको',
  'by {name}': '{name} द्वारा',
  '{count} token issued': '{count} टोकन जारी',
  '{count} tokens issued': '{count} टोकन जारी',
  'Open tokens - tap one to add to that customer':
    'खुला टोकन - ग्राहकको बिलमा थप्न टोकनमा थिच्नुहोस्',
  'Menu': 'मेनु',
  'Search items': 'वस्तु खोज्नुहोस्',
  'Search menu items': 'मेनुका वस्तु खोज्नुहोस्',
  'Clear search': 'खोज हटाउनुहोस्',
  '{shown} of {total}': '{total} मध्ये {shown}',
  '{count} items': '{count} वस्तु',
  'Nothing matches "{query}"': '"{query}" सँग मिल्ने केही भेटिएन',
  'On this token': 'यो टोकनमा',
  'item': 'वस्तु',
  'items': 'वस्तु',
  'Remove one {name}': 'एक {name} घटाउनुहोस्',
  'Add one {name}': 'एक {name} थप्नुहोस्',
  'No menu items available': 'कुनै मेनु वस्तु उपलब्ध छैन',
  'Add some items to get started.': 'सुरु गर्न केही वस्तु थप्नुहोस्।',
  'Error: {message}': 'त्रुटि: {message}',
  'Try Again': 'फेरि प्रयास गर्नुहोस्',

  // dashboard notifications
  'Open the counter before taking orders.': 'अर्डर लिनु अघि काउन्टर खोल्नुहोस्।',
  'Token #{n} started.': 'टोकन #{n} सुरु भयो।',
  'Token #{n} started. Add items to it.': 'टोकन #{n} सुरु भयो। यसमा वस्तु थप्नुहोस्।',
  'Token #{n} is empty - add items to it first.': 'टोकन #{n} खाली छ - पहिले यसमा वस्तु थप्नुहोस्।',
  'Now adding to token #{n}.': 'अब टोकन #{n} मा थपिँदै छ।',
  'Could not add the item.': 'वस्तु थप्न सकिएन।',
  'Could not create a token.': 'टोकन बनाउन सकिएन।',
  '{name} is not on token #{n}.': '{name} टोकन #{n} मा छैन।',

  // -------------------------------------------------------------------- orders
  "Today's Sales": 'आजको बिक्री',
  'Each token is one customer. Tap a token to see its items, add more, or take payment.':
    'एउटा टोकन भनेको एक ग्राहक हो। वस्तु हेर्न, थप्न वा भुक्तानी लिन टोकनमा थिच्नुहोस्।',
  'Completed sales for today - void one to correct a mistake':
    'आजका सम्पन्न बिक्री - गल्ती सच्याउन बदर गर्नुहोस्',
  'Bill': 'बिल',
  'Print a Bill': 'बिल प्रिन्ट गर्नुहोस्',
  'No open tokens': 'कुनै खुला टोकन छैन',
  'Add items from the dashboard to start an order.':
    'अर्डर सुरु गर्न ड्यासबोर्डबाट वस्तु थप्नुहोस्।',
  'New Order': 'नयाँ अर्डर',
  'In progress': 'चलिरहेको',
  'in progress': 'चलिरहेको',
  'Pay together with other tokens': 'अन्य टोकनसँगै भुक्तानी गर्नुहोस्',
  'Add token {n} to the combined bill': 'टोकन {n} लाई संयुक्त बिलमा थप्नुहोस्',
  'Remove token {n} from the combined bill': 'टोकन {n} लाई संयुक्त बिलबाट हटाउनुहोस्',
  'token': 'टोकन',
  'tokens': 'टोकन',
  '{count} token': '{count} टोकन',
  '{count} tokens': '{count} टोकन',
  'Clear': 'हटाउनुहोस्',
  'Pay together': 'सँगै भुक्तानी',
  'Token #{n}': 'टोकन #{n}',
  'Rs {amount} each': ' रु {amount}',
  'Remove this item': 'यो वस्तु हटाउनुहोस्',
  'Print or share this bill': 'यो बिल प्रिन्ट वा सेयर गर्नुहोस्',
  'Print or share the bill for token {n}': 'टोकन {n} को बिल प्रिन्ट वा सेयर गर्नुहोस्',
  'Add Items': 'वस्तु थप्नुहोस्',
  'Pay': 'भुक्तानी',
  'Take Payment -': 'भुक्तानी लिनुहोस् -',
  '{n}m': '{n} मिनेट',
  '{h}h {m}m': '{h} घण्टा {m} मिनेट',

  // orders notifications
  "Failed to load today's sales.": 'आजको बिक्री लोड गर्न सकिएन।',
  'Paid, but {count} line(s) could not be settled.':
    'भुक्तानी भयो, तर {count} वटा लाइन मिलाउन सकिएन।',
  'Put on account for {name}.': '{name} को नाममा उधारो राखियो।',
  'customer': 'ग्राहक',
  'Token #{n} paid.': 'टोकन #{n} को भुक्तानी भयो।',
  '{count} tokens paid as one bill.': '{count} टोकन एउटै बिलमा भुक्तानी भयो।',
  'Failed to complete the order. Please try again.':
    'अर्डर पूरा गर्न सकिएन। कृपया फेरि प्रयास गर्नुहोस्।',
  'Remove {name} from token #{n}?': '{name} लाई टोकन #{n} बाट हटाउने?',
  'Item removed.': 'वस्तु हटाइयो।',
  'Failed to remove the item. Please try again.':
    'वस्तु हटाउन सकिएन। कृपया फेरि प्रयास गर्नुहोस्।',
  "Void the sale of {name} for Rs {amount}? This removes it from today's revenue.":
    '{name} को रु {amount} को बिक्री बदर गर्ने? यसले आजको आम्दानीबाट हटाउँछ।',
  'Sale voided.': 'बिक्री बदर गरियो।',
  'Failed to void the sale.': 'बिक्री बदर गर्न सकिएन।',

  // ----------------------------------------------------------- completed sales
  'Sales Today': 'आजको बिक्री संख्या',
  'Revenue': 'आम्दानी',
  'No sales yet today': 'आज अहिलेसम्म कुनै बिक्री छैन',
  'Completed orders will appear here.': 'सम्पन्न अर्डरहरू यहाँ देखिनेछन्।',
  'Cash': 'नगद',
  'Bank': 'बैंक',
  'Due': 'उधारो',
  'Paid': 'भुक्तानी भयो',
  'Voided': 'बदर गरिएको',
  'Void': 'बदर',
  'Void this sale': 'यो बिक्री बदर गर्नुहोस्',
  'Discount: -Rs {amount}': 'छुट: -रु {amount}',

  // ----------------------------------------------------------------- item card
  '{count} sold': '{count} बिक्री',
  'Out of stock': 'स्टक सकियो',
  'Out of Stock': 'स्टक सकियो',
  '{count} in stock': 'स्टकमा {count}',

  // -------------------------------------------------------------- counter modal
  'Enter the cash counted in the drawer': 'दराजमा गनिएको नगद लेख्नुहोस्',
  'Enter the opening cash float': 'सुरुको नगद रकम लेख्नुहोस्',
  'Counter closed and the drawer balances.': 'काउन्टर बन्द भयो र हिसाब मिल्यो।',
  'Counter closed. Drawer is over by Rs {amount}.': 'काउन्टर बन्द भयो। दराजमा रु {amount} बढी छ।',
  'Counter closed. Drawer is short by Rs {amount}.': 'काउन्टर बन्द भयो। दराजमा रु {amount} कम छ।',
  'Counter opened. Token numbers start at 1.': 'काउन्टर खुल्यो। टोकन नम्बर १ बाट सुरु हुन्छ।',
  'Something went wrong. Please try again.': 'केही गडबड भयो। कृपया फेरि प्रयास गर्नुहोस्।',
  'Opening float': 'सुरुको नगद',
  'Cash sales': 'नगद बिक्री',
  'Dues collected in cash': 'नगदमा उठेको उधारो',
  'Expenses paid out': 'भुक्तानी गरिएको खर्च',
  'Moved to savings': 'बचतमा सारिएको',
  'Taken from savings': 'बचतबाट झिकिएको',
  'Drawer should hold': 'दराजमा हुनुपर्ने',
  'Bank / digital sales (not in drawer)': 'बैंक / डिजिटल बिक्री (दराजमा छैन)',
  'Sold on due (not collected)': 'उधारोमा बिक्री (उठेको छैन)',
  'Orders settled': 'मिलान भएका अर्डर',
  'Tokens issued': 'जारी टोकन',
  'Cash counted in drawer (Rs.)': 'दराजमा गनिएको नगद (रु.)',
  'Opening cash float (Rs.)': 'सुरुको नगद (रु.)',
  'The change you are starting the day with. Enter 0 if there is none.':
    'दिन सुरु गर्दाको खुद्रा नगद। नभए ० लेख्नुहोस्।',
  'The drawer balances exactly.': 'दराजको हिसाब ठ्याक्कै मिल्यो।',
  'Drawer is over by Rs {amount}.': 'दराजमा रु {amount} बढी छ।',
  'Drawer is short by Rs {amount}.': 'दराजमा रु {amount} कम छ।',
  'Notes (optional)': 'टिप्पणी (वैकल्पिक)',
  'Anything worth recording about this shift': 'यो पालीबारे लेख्नुपर्ने कुनै कुरा',
  'Working...': 'काम हुँदै छ...',

  // ------------------------------------------------------------- payment modal
  'Payment - {label}': 'भुक्तानी - {label}',
  'Complete Order': 'अर्डर पूरा गर्नुहोस्',
  'Complete Orders': 'अर्डरहरू पूरा गर्नुहोस्',
  'Order Details': 'अर्डरको विवरण',
  'Total Amount: Rs {amount}': 'जम्मा रकम: रु {amount}',
  'Discount': 'छुट',
  'Amount (Rs.)': 'रकम (रु.)',
  'Percentage (%)': 'प्रतिशत (%)',
  'Discount Amount (Rs.)': 'छुट रकम (रु.)',
  'Enter discount amount': 'छुट रकम लेख्नुहोस्',
  'Discount Percentage (%)': 'छुट प्रतिशत (%)',
  'Enter discount percentage': 'छुट प्रतिशत लेख्नुहोस्',
  'Final Amount:': 'अन्तिम रकम:',
  'Discount Applied: Rs {amount}': 'लागू भएको छुट: रु {amount}',
  'Payment Method': 'भुक्तानीको तरिका',
  'Due Details': 'उधारोको विवरण',
  'Retry': 'फेरि प्रयास',
  'Customer list needs a newer backend - enter the details by hand for now.':
    'ग्राहक सूचीका लागि नयाँ ब्याकएन्ड चाहिन्छ - अहिलेलाई हातले विवरण लेख्नुहोस्।',
  'Could not load saved customers - enter the details by hand.':
    'सुरक्षित ग्राहक लोड गर्न सकिएन - हातले विवरण लेख्नुहोस्।',
  'Already owes Rs {amount} across {count} {unit}':
    'पहिले नै {count} {unit} मा रु {amount} बाँकी छ',
  'bill': 'बिल',
  'bills': 'बिल',
  'Change': 'बदल्नुहोस्',
  'Customer Name': 'ग्राहकको नाम',
  'Enter customer name': 'ग्राहकको नाम लेख्नुहोस्',
  'Mobile Number': 'मोबाइल नम्बर',
  'Enter mobile number': 'मोबाइल नम्बर लेख्नुहोस्',
  'That number is already on file as': 'यो नम्बर पहिले नै दर्ता छ -',
  '. This bill will be added to their account.': '। यो बिल उनको खातामा थपिनेछ।',
  'Pick an existing customer instead': 'बरु भएकै ग्राहक छान्नुहोस्',
  'Search by name or mobile': 'नाम वा मोबाइलबाट खोज्नुहोस्',
  'Loading customers...': 'ग्राहक लोड हुँदै छ...',
  'No customer matches "{query}".': '"{query}" सँग मिल्ने ग्राहक भेटिएन।',
  'New customer': 'नयाँ ग्राहक',
  'Rs {amount} goes on account and stays outstanding until it is settled from the Dues page.':
    'रु {amount} उधारोमा जान्छ र उधारो पृष्ठबाट मिलान नगरेसम्म बाँकी रहन्छ।',
  'Processing...': 'प्रक्रिया हुँदै छ...',
  'Put on Account': 'उधारोमा राख्नुहोस्',

  // ------------------------------------------------------------- counter page
  'The drawer for this session, and every session closed before it.':
    'यो सत्रको दराज, र यसअघि बन्द भएका सबै सत्र।',
  'Counter open': 'काउन्टर खुला छ',
  'Counter closed': 'काउन्टर बन्द छ',
  'Open': 'खुला',
  'Closed': 'बन्द',
  'Bank sales': 'बैंक बिक्री',
  'Sold on due': 'उधारोमा बिक्री',
  'Dues collected': 'उठेको उधारो',
  'Counted': 'गनिएको',
  'Expected': 'हुनुपर्ने',
  'Difference': 'फरक',
  // 'Expenses' and 'Orders' are already defined in the navigation block above -
  // the Counter page reuses those same keys rather than redefining them.
  'Could not load past sessions.': 'पुराना सत्र लोड गर्न सकिएन।',
  'Could not clear the unpaid lines.': 'बाँकी लाइन हटाउन सकिएन।',
  '{count} unpaid line(s) will be deleted and their stock returned. Completed sales and expenses are not affected.':
    '{count} बाँकी लाइन मेटिनेछन् र तिनको स्टक फिर्ता हुनेछ। सम्पन्न बिक्री र खर्चमा असर पर्दैन।',
  '{count} unpaid line(s). These must be settled or removed before the counter will close.':
    '{count} बाँकी लाइन छन्। काउन्टर बन्द गर्नुअघि यी मिलाउनु वा हटाउनुपर्छ।',
  'Open tokens': 'खुला टोकन',
  'Open the counter with a cash float to start taking orders. Token numbers restart at 1 each session.':
    'अर्डर लिन सुरु गर्न नगद हालेर काउन्टर खोल्नुहोस्। हरेक सत्रमा टोकन नम्बर १ बाट सुरु हुन्छ।',
  'Housekeeping': 'सरसफाइ',
  "Clears today's unpaid lines and returns their stock. Completed sales and expenses are kept.":
    'आजका बाँकी लाइन हटाउँछ र तिनको स्टक फिर्ता गर्छ। सम्पन्न बिक्री र खर्च रहन्छन्।',
  'Clearing...': 'हटाउँदै छ...',
  'Clear unpaid lines': 'बाँकी लाइन हटाउनुहोस्',
  'Clear unpaid lines ({count})': 'बाँकी लाइन हटाउनुहोस् ({count})',
  'Past sessions': 'पुराना सत्र',
  'No closed sessions': 'कुनै बन्द सत्र छैन',
  'Sessions appear here once the counter has been closed.':
    'काउन्टर बन्द भएपछि सत्रहरू यहाँ देखिन्छन्।',
  'Balanced': 'मिलेको',
  'Over': 'बढी',
  'Short': 'कम',
  'Closed by {name}': '{name} द्वारा बन्द',
  'Checking the counter...': 'काउन्टर जाँच्दै...',

  // -------------------------------------------------------------- notes modal
  "Tomorrow's Reminders": 'भोलिका सम्झनाहरू',
  'Add a reminder for tomorrow...': 'भोलिको लागि सम्झना थप्नुहोस्...',
  'No Reminders Yet': 'अहिलेसम्म कुनै सम्झना छैन',
  'Add your first reminder for tomorrow!': 'भोलिको लागि पहिलो सम्झना थप्नुहोस्!',
  '{count} reminder total': 'जम्मा {count} सम्झना',
  '{count} reminders total': 'जम्मा {count} सम्झना',
  '{count} completed': '{count} पूरा भयो',

  // ------------------------------------------------------------ app chrome
  'Access Denied': 'पहुँच अस्वीकृत',
  "You don't have permission to access this page.": 'यो पृष्ठ हेर्ने अनुमति तपाईंसँग छैन।',
  'Required role:': 'आवश्यक भूमिका:',
  'Your role:': 'तपाईंको भूमिका:',
  'Unknown': 'थाहा छैन',
  'Install app': 'एप इन्स्टल गर्नुहोस्',
  'Install App': 'एप इन्स्टल गर्नुहोस्',
  'Dismiss': 'हटाउनुहोस्',

  // -------------------------------------------------------- change password
  'Enter your current and new password': 'हालको र नयाँ पासवर्ड लेख्नुहोस्',
  'The new password must be at least 6 characters': 'नयाँ पासवर्ड कम्तीमा ६ अक्षरको हुनुपर्छ',
  'The new passwords do not match': 'नयाँ पासवर्डहरू मिलेनन्',
  'Password changed successfully.': 'पासवर्ड सफलतापूर्वक परिवर्तन भयो।',
  'Could not change the password.': 'पासवर्ड परिवर्तन गर्न सकिएन।',
  'Current password': 'हालको पासवर्ड',
  'New password': 'नयाँ पासवर्ड',
  'At least 6 characters.': 'कम्तीमा ६ अक्षर।',
  'Confirm new password': 'नयाँ पासवर्ड पुष्टि गर्नुहोस्',
  'Saving...': 'सुरक्षित हुँदै छ...',

  // ------------------------------------------------------------ image upload
  'Please select an image file': 'कृपया कुनै तस्बिर फाइल छान्नुहोस्',
  'Image size should be less than 5MB': 'तस्बिरको आकार ५MB भन्दा कम हुनुपर्छ',
  'Preview': 'पूर्वावलोकन',
  'Uploading...': 'अपलोड हुँदै छ...',
  'Click to upload image': 'तस्बिर अपलोड गर्न थिच्नुहोस्',
  'PNG, JPG up to 5MB': 'PNG, JPG ५MB सम्म',

  // --------------------------------------------------------- add / edit item
  'Add New Menu Item': 'नयाँ मेनु वस्तु थप्नुहोस्',
  'Basic Information': 'आधारभूत जानकारी',
  'Item Name (English)': 'वस्तुको नाम (अंग्रेजी)',
  'e.g., Milk Tea, Chicken Momo': 'जस्तै: Milk Tea, Chicken Momo',
  '— optional': '— वैकल्पिक',
  'Price (Rs.)': 'मूल्य (रु.)',
  'Initial Stock Quantity': 'सुरुको स्टक परिमाण',
  'Leave empty if not tracking stock': 'स्टक नराख्ने भए खाली छोड्नुहोस्',
  'Include in customer menu': 'ग्राहक मेनुमा राख्नुहोस्',
  'Customers will be able to order this item': 'ग्राहकहरूले यो वस्तु अर्डर गर्न सक्नेछन्',
  'Item Image': 'वस्तुको तस्बिर',
  'Upload Image (Optional)': 'तस्बिर अपलोड गर्नुहोस् (वैकल्पिक)',
  'Recommended: Square image, at least 300x300px for best quality':
    'सिफारिस: वर्गाकार तस्बिर, राम्रो गुणस्तरका लागि कम्तीमा 300x300px',
  'Inventory Management': 'स्टक व्यवस्थापन',
  'Enable inventory tracking': 'स्टक ट्र्याकिङ सक्रिय गर्नुहोस्',
  'Track stock levels and get low stock alerts for this item':
    'यो वस्तुको स्टक हेर्नुहोस् र स्टक कम हुँदा सूचना पाउनुहोस्',
  'Low Stock Alert Threshold': 'कम स्टक सूचना सीमा',
  "You'll receive notifications when stock falls below this number":
    'स्टक यो संख्याभन्दा तल झरेमा तपाईंले सूचना पाउनुहुनेछ',
  'Adding Item...': 'वस्तु थपिँदै छ...',
  'Add Item': 'वस्तु थप्नुहोस्',
  'Please provide valid item name and price': 'कृपया मान्य वस्तुको नाम र मूल्य दिनुहोस्',
  'Please provide a valid stock quantity': 'कृपया मान्य स्टक परिमाण दिनुहोस्',
  'Item added successfully!': 'वस्तु सफलतापूर्वक थपियो!',
  'Failed to add item': 'वस्तु थप्न सकिएन',

  // -------------------------------------------------------------- add expense
  'Add New Expense': 'नयाँ खर्च थप्नुहोस्',
  'Expense Details': 'खर्चको विवरण',
  'Category': 'श्रेणी',
  'Select an expense category': 'खर्चको श्रेणी छान्नुहोस्',
  'Choose the category for this expense': 'यो खर्चको श्रेणी छान्नुहोस्',
  'Description': 'विवरण',
  'e.g., Office supplies for marketing team, Monthly electricity bill':
    'जस्तै: कार्यालय सामान, मासिक बिजुली बिल',
  'Enter a detailed description of the expense': 'खर्चको विस्तृत विवरण लेख्नुहोस्',
  'Enter the total expense amount': 'जम्मा खर्च रकम लेख्नुहोस्',
  'When did this expense occur?': 'यो खर्च कहिले भयो?',
  'Quick Amount Selection': 'छिटो रकम छनोट',
  'Click to quickly set common amounts': 'सामान्य रकम छिटो राख्न थिच्नुहोस्',
  'Add Expense': 'खर्च थप्नुहोस्',

  // ------------------------------------------------------------ expenses page
  'Track and manage your business expenses': 'आफ्नो व्यवसायको खर्च हेर्नुहोस् र व्यवस्थापन गर्नुहोस्',
  'Manage Items': 'वस्तु व्यवस्थापन',
  "Today's Expenses": 'आजको खर्च',
  'Total Expenses': 'जम्मा खर्च',
  'Expenses by Category': 'श्रेणी अनुसार खर्च',
  'Loading expenses...': 'खर्च लोड हुँदै छ...',
  'No Expenses Yet': 'अहिलेसम्म कुनै खर्च छैन',
  'Start by adding your first expense.': 'पहिलो खर्च थपेर सुरु गर्नुहोस्।',
  'Select category': 'श्रेणी छान्नुहोस्',
  'Enter expense description': 'खर्चको विवरण लेख्नुहोस्',
  'Managed from the Staff page': 'कर्मचारी पृष्ठबाट व्यवस्थापन गरिन्छ',
  'Edit expense': 'खर्च सम्पादन गर्नुहोस्',
  'Delete expense': 'खर्च मेट्नुहोस्',
  'Are you sure you want to delete this expense?': 'के तपाईं यो खर्च मेट्न निश्चित हुनुहुन्छ?',
  'Failed to fetch expenses': 'खर्च ल्याउन सकिएन',
  'Expense added successfully!': 'खर्च सफलतापूर्वक थपियो!',
  'Failed to add expense': 'खर्च थप्न सकिएन',
  'Expense updated successfully!': 'खर्च सफलतापूर्वक अद्यावधिक भयो!',
  'Failed to update expense': 'खर्च अद्यावधिक गर्न सकिएन',
  'Expense deleted successfully!': 'खर्च सफलतापूर्वक मेटियो!',
  'Failed to delete expense': 'खर्च मेट्न सकिएन',

  // --------------------------------------------------------- expense categories
  'Manage Expense Categories': 'खर्च श्रेणी व्यवस्थापन',
  'Add New Category': 'नयाँ श्रेणी थप्नुहोस्',
  'Add Category': 'श्रेणी थप्नुहोस्',
  'Category Name': 'श्रेणीको नाम',
  'e.g., Office Supplies, Utilities, Raw Materials': 'जस्तै: कार्यालय सामान, महसुल, कच्चा पदार्थ',
  'Create categories that match your business expense types for easier tracking':
    'सजिलो हिसाबका लागि आफ्नो व्यवसायको खर्च अनुसार श्रेणी बनाउनुहोस्',
  'Existing Categories': 'भएका श्रेणीहरू',
  'No Categories Yet': 'अहिलेसम्म कुनै श्रेणी छैन',
  'Start by adding your first expense category above. This will help you organize and track your business expenses more efficiently.':
    'माथि पहिलो खर्च श्रेणी थपेर सुरु गर्नुहोस्। यसले खर्च मिलाएर राख्न सजिलो बनाउँछ।',
  '💡 Popular categories: Office Supplies, Utilities, Marketing, Travel':
    '💡 प्रचलित श्रेणी: कार्यालय सामान, महसुल, मार्केटिङ, यात्रा',
  'Edit category': 'श्रेणी सम्पादन गर्नुहोस्',
  'Delete category': 'श्रेणी मेट्नुहोस्',
  'Cancel editing': 'सम्पादन रद्द गर्नुहोस्',
  'Save changes': 'परिवर्तन सुरक्षित गर्नुहोस्',
  'Are you sure you want to delete this expense item?': 'के तपाईं यो खर्च वस्तु मेट्न निश्चित हुनुहुन्छ?',
  'Expense item added successfully!': 'खर्च वस्तु सफलतापूर्वक थपियो!',
  'Expense item updated successfully!': 'खर्च वस्तु सफलतापूर्वक अद्यावधिक भयो!',
  'Expense item deleted successfully!': 'खर्च वस्तु सफलतापूर्वक मेटियो!',

  // ----------------------------------------------------------------- dues page
  'Bills sold on credit, and who owes the money on each one.':
    'उधारोमा बेचिएका बिल, र प्रत्येकमा कसले पैसा तिर्नुपर्ने हो।',
  'Could not load the dues.': 'उधारो लोड गर्न सकिएन।',
  'Reverse this payment': 'यो भुक्तानी उल्टाउनुहोस्',
  'Payment reversed.': 'भुक्तानी उल्टाइयो।',
  'Amount to pay': 'तिर्नुपर्ने रकम',
  'On account - payment due': 'उधारोमा - भुक्तानी बाँकी',
  'Paid at': 'भुक्तानी भएको',

  // -------------------------------------------------------------- savings page
  'What the cafe has put by, fund by fund, and every deposit and withdrawal behind it.':
    'क्याफेले जम्मा गरेको रकम, कोष अनुसार, र त्यसभित्रका सबै जम्मा र झिकाइ।',
  'Could not load savings.': 'बचत लोड गर्न सकिएन।',
  'Could not load this account.': 'यो खाता लोड गर्न सकिएन।',
  'Loading account...': 'खाता लोड हुँदै छ...',
  'Fund': 'कोष',
  'No funds yet': 'अहिलेसम्म कुनै कोष छैन',
  'New fund, e.g. Emergency fund': 'नयाँ कोष, जस्तै: आपत्कालीन कोष',
  'Create a fund above — money is saved towards something, so a name helps.':
    'माथि कोष बनाउनुहोस् — पैसा कुनै उद्देश्यका लागि जम्मा हुन्छ, त्यसैले नाम राख्दा सजिलो हुन्छ।',
  'Create a fund first.': 'पहिले कोष बनाउनुहोस्।',
  'Money you put by will be listed here with the date it went in.':
    'तपाईंले जम्मा गरेको रकम मितिसहित यहाँ देखिनेछ।',
  'Enter an amount greater than zero.': 'शून्यभन्दा बढी रकम लेख्नुहोस्।',
  'Moved by': 'सारेको',
  'This is cash leaving the till, so it is also recorded under Expenses automatically.':
    'यो नगद दराजबाट जाने भएकाले स्वतः खर्चमा पनि दर्ता हुन्छ।',

  // ---------------------------------------------------------------- staff page
  'Track salaries, advances and what each staff member is owed':
    'तलब, पेस्की र प्रत्येक कर्मचारीलाई तिर्न बाँकी रकम हेर्नुहोस्',
  'Staff Accounts': 'कर्मचारी खाता',
  'Add Staff': 'कर्मचारी थप्नुहोस्',
  'Loading staff...': 'कर्मचारी लोड हुँदै छ...',
  'No Staff Yet': 'अहिलेसम्म कुनै कर्मचारी छैन',
  'Add your staff to start tracking salaries and advances.':
    'तलब र पेस्की हेर्न सुरु गर्न आफ्ना कर्मचारी थप्नुहोस्।',
  'Edit staff member': 'कर्मचारी सम्पादन गर्नुहोस्',
  'Delete staff member': 'कर्मचारी मेट्नुहोस्',
  'Staff member added successfully!': 'कर्मचारी सफलतापूर्वक थपियो!',
  'Staff member updated successfully!': 'कर्मचारी सफलतापूर्वक अद्यावधिक भयो!',
  'Position': 'पद',
  'e.g., Cook, Waiter': 'जस्तै: भान्से, वेटर',
  'e.g., Ram Bahadur': 'जस्तै: राम बहादुर',
  'Monthly Salary (Rs.)': 'मासिक तलब (रु.)',
  'Join Date': 'सुरु मिति',
  'Last Working Day': 'अन्तिम कार्य दिन',
  'Leave empty if still working. Salary stops on this date.':
    'अझै काम गरिरहेको भए खाली छोड्नुहोस्। यही मितिमा तलब रोकिन्छ।',
  'Anything worth remembering about this staff member': 'यो कर्मचारीबारे सम्झनुपर्ने कुनै कुरा',
  'Currently working': 'हाल कार्यरत',
  'Former': 'पूर्व',
  'Experienced staff': 'अनुभवी कर्मचारी',
  'Salary builds up day by day from the join date': 'सुरु मितिदेखि दिनैपिच्छे तलब जोडिँदै जान्छ',

  // ------------------------------------------------------------- staff ledger
  'Record Entry': 'प्रविष्टि दर्ता गर्नुहोस्',
  'Record advance, salary or bonus': 'पेस्की, तलब वा बोनस दर्ता गर्नुहोस्',
  'Record an advance or a salary payment to start the account.':
    'खाता सुरु गर्न पेस्की वा तलब भुक्तानी दर्ता गर्नुहोस्।',
  'Entry': 'प्रविष्टि',
  'Entry Type': 'प्रविष्टिको किसिम',
  'No entries yet.': 'अहिलेसम्म कुनै प्रविष्टि छैन।',
  'Edit entry': 'प्रविष्टि सम्पादन गर्नुहोस्',
  'Delete entry': 'प्रविष्टि मेट्नुहोस्',
  'Remove this entry': 'यो प्रविष्टि हटाउनुहोस्',
  'Delete this entry? The matching expense entry is removed too.':
    'यो प्रविष्टि मेट्ने? सम्बन्धित खर्च प्रविष्टि पनि हट्नेछ।',
  'Entry recorded successfully!': 'प्रविष्टि सफलतापूर्वक दर्ता भयो!',
  'Entry updated successfully!': 'प्रविष्टि सफलतापूर्वक अद्यावधिक भयो!',
  'Entry deleted successfully!': 'प्रविष्टि सफलतापूर्वक मेटियो!',
  'Entry removed.': 'प्रविष्टि हटाइयो।',
  'What this was for': 'यो केका लागि थियो',
  'e.g., Dashain advance, broke two plates': 'जस्तै: दशैं पेस्की, दुई थाल फुट्यो',
  'Note': 'टिप्पणी',
  'Note (optional)': 'टिप्पणी (वैकल्पिक)',
  'History': 'इतिहास',
  'Quick Amount': 'छिटो रकम',
  'Nothing here yet': 'यहाँ अहिलेसम्म केही छैन',

  // -------------------------------------------------------------- reports page
  'Business insights and analytics': 'व्यवसायको जानकारी र विश्लेषण',
  'Loading report data...': 'रिपोर्ट डाटा लोड हुँदै छ...',
  'No Data Available': 'कुनै डाटा उपलब्ध छैन',
  'Export CSV': 'CSV निर्यात गर्नुहोस्',
  'Download this report as a CSV spreadsheet': 'यो रिपोर्ट CSV स्प्रेडसिटका रूपमा डाउनलोड गर्नुहोस्',
  'Report downloaded.': 'रिपोर्ट डाउनलोड भयो।',
  'Refresh': 'रिफ्रेस गर्नुहोस्',
  'Total Revenue': 'जम्मा आम्दानी',
  'Final Revenue': 'अन्तिम आम्दानी',
  'Total Discounts': 'जम्मा छुट',
  'Net Profit/Loss': 'खुद नाफा/नोक्सान',
  'Profit & Loss': 'नाफा र नोक्सान',
  'How this was worked out': 'यो कसरी निकालियो',
  'Payment Breakdown': 'भुक्तानीको विभाजन',
  'Cash Payments': 'नगद भुक्तानी',
  'Bank Payments': 'बैंक भुक्तानी',
  'Sold on Due': 'उधारोमा बिक्री',
  'Items Sold': 'बिक्री भएका वस्तु',
  'Item': 'वस्तु',
  'Qty': 'परिमाण',
  'Rate': 'दर',

  // ---------------------------------------------------------------- bill modal
  'Token Number': 'टोकन नम्बर',
  'Enter a valid token number': 'मान्य टोकन नम्बर लेख्नुहोस्',
  'Loading bill...': 'बिल लोड हुँदै छ...',
  'Bill unavailable': 'बिल उपलब्ध छैन',
  'Bill To': 'बिल पाउने',
  'Bill to': 'बिल पाउने',
  'Enter a name for the bill': 'बिलका लागि नाम लेख्नुहोस्',
  'Customer or company name': 'ग्राहक वा कम्पनीको नाम',
  'Subtotal': 'उप-जम्मा',
  'Thank you': 'धन्यवाद',
  'Thank you for your visit': 'पाल्नुभएकोमा धन्यवाद',
  'Scan or send': 'स्क्यान गर्नुहोस् वा पठाउनुहोस्',
  'The customer can open this without an account.': 'ग्राहकले खाता नबनाई यो खोल्न सक्छन्।',
  'Could not copy - select the link and copy it by hand.':
    'कपी गर्न सकिएन - लिंक छानेर हातले कपी गर्नुहोस्।',
  'WhatsApp': 'व्हाट्सएप',
  'WhatsApp number': 'व्हाट्सएप नम्बर',
  'WhatsApp number with country code (optional)': 'देशको कोडसहित व्हाट्सएप नम्बर (वैकल्पिक)',

  // --------------------------------------------------------------- contact page
  'Contact Customer Support': 'ग्राहक सहायतामा सम्पर्क गर्नुहोस्',
  'Need help with your order or have questions? Our friendly customer support team is here to assist you.':
    'अर्डरमा सहयोग चाहियो वा प्रश्न छ? हाम्रो ग्राहक सहायता टोली तपाईंलाई सहयोग गर्न तयार छ।',
  'Customer Support Line': 'ग्राहक सहायता लाइन',
  'Available for calls and WhatsApp': 'कल र व्हाट्सएपका लागि उपलब्ध',
  'Call Now': 'अहिले कल गर्नुहोस्',
  'Support Information': 'सहायता जानकारी',
  'Business Hours': 'कार्य समय',
  'Monday - Sunday': 'सोमबार - आइतबार',
  '9:00 AM - 10:00 PM': 'बिहान ९:०० - राति १०:००',
  'Response Time': 'जवाफ आउने समय',
  'Calls: Immediate': 'कल: तुरुन्तै',
  'WhatsApp: Within 5 minutes': 'व्हाट्सएप: ५ मिनेटभित्र',
  'Support Team': 'सहायता टोली',
  'Multi-language support': 'बहुभाषिक सहायता',
  'Emergency Contact': 'आपत्कालीन सम्पर्क',
  'For urgent issues or complaints, please call our primary contact number immediately.':
    'जरुरी समस्या वा गुनासोका लागि कृपया हाम्रो मुख्य नम्बरमा तुरुन्तै कल गर्नुहोस्।',
  'Phone Number': 'फोन नम्बर',

  // ---------------------------------------------------------------- leftovers
  'Add First Staff Member': 'पहिलो कर्मचारी थप्नुहोस्',
  'Add First Expense': 'पहिलो खर्च थप्नुहोस्',
  'Monthly Payroll': 'मासिक तलब खर्च',
  'You Owe': 'तपाईंले तिर्नुपर्ने',
  'Paid Ahead': 'अग्रिम भुक्तानी',
  'Delete {name}?\n\nTheir entire account history will be removed, including the expense entries created from their advances and salary payments. This cannot be undone.':
    '{name} लाई मेट्ने?\n\nउनको सम्पूर्ण खाता इतिहास हट्नेछ, पेस्की र तलब भुक्तानीबाट बनेका खर्च प्रविष्टि सहित। यो फिर्ता गर्न मिल्दैन।',
  '{name} deleted successfully!': '{name} सफलतापूर्वक मेटियो!',
  'Salary earned so far': 'अहिलेसम्म कमाएको तलब',
  'Bonuses': 'बोनस',
  'Deductions': 'कटौती',
  'Advances taken': 'लिएको पेस्की',
  'Salary paid': 'भुक्तानी भएको तलब',
  'All funds': 'सबै कोष',
  "Close '{name}'? Its history is kept.": "'{name}' बन्द गर्ने? यसको इतिहास रहनेछ।",
  'Remove the {amount} {type} of {date}? The balance goes back to what it was.':
    '{date} को {amount} {type} हटाउने? बाँकी रकम पहिलेकै अवस्थामा फर्कन्छ।',
  'Only Rs {amount} is outstanding on this due.': 'यो उधारोमा रु {amount} मात्र बाँकी छ।',
  'Failed to fetch the {period} report': '{period} को रिपोर्ट ल्याउन सकिएन',
  'Done': 'भयो',
  'Create and manage expense categories to streamline your expense tracking. These categories will appear as quick options when adding new expenses.':
    'खर्चको हिसाब सजिलो बनाउन खर्च श्रेणी बनाउनुहोस् र व्यवस्थापन गर्नुहोस्। नयाँ खर्च थप्दा यी श्रेणी छिटो विकल्पका रूपमा देखिनेछन्।',
  'Changes are saved automatically. Categories will be available when adding new expenses.':
    'परिवर्तन स्वतः सुरक्षित हुन्छ। नयाँ खर्च थप्दा श्रेणीहरू उपलब्ध हुनेछन्।',

  // ------------------------------------------------------------------- general
  // Common words reused across screens - add your own below this line.
  'Save': 'सुरक्षित गर्नुहोस्',
  'Cancel': 'रद्द गर्नुहोस्',
  'Confirm': 'पुष्टि गर्नुहोस्',
  'Delete': 'मेट्नुहोस्',
  'Edit': 'सम्पादन गर्नुहोस्',
  'Add': 'थप्नुहोस्',
  'Close': 'बन्द गर्नुहोस्',
  'Search': 'खोज्नुहोस्',
  'Loading...': 'लोड हुँदै छ...',
  'Total': 'जम्मा',
  'Amount': 'रकम',
  'Date': 'मिति',
  'Name': 'नाम',
  'Print': 'प्रिन्ट गर्नुहोस्',
};

/** Every language the app offers. Add a new one by adding a dictionary above. */
export const LANGUAGES = {
  en: { code: 'en', name: 'English', nativeName: 'English', dict: {} },
  ne: { code: 'ne', name: 'Nepali', nativeName: 'नेपाली', dict: ne },
};

export default LANGUAGES;
